import { UpdateGraphReply, UpdateGraphRequest } from "@/backend/express/controllers/graphController";
import { Client } from "./client";

export class GraphController {
  private client: Client;

  constructor() {
    this.client = new Client();
  }

  async updateGraph(request: UpdateGraphRequest): Promise<UpdateGraphReply> {
    return this.client.update(`/api/graphs/${request.graph.id}`, request);
  }
}

